exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-078bc3f9] #al-show-details .fa-chevron-up{display:none}[data-v-078bc3f9] #al-show-details.active .fa-chevron-up{display:inline-block}[data-v-078bc3f9] #al-show-details.active .fa-chevron-down{display:none}", ""]);

// exports
